interface OpenWindowPopupOptions {
  onClose?: () => void;
  title?: string;
  width?: number;
  height?: number;
  toolbar?: boolean;
  menubar?: boolean;
  scrollbars?: boolean;
  resizable?: boolean;
  centerScreen?: boolean;
}

// TODO: it doesn't work that open in the center of the screen. fix it.
export function openWindowPopup(
  url: string,
  {
    onClose,
    title = "Popup",
    width = 500,
    height = 600,
    toolbar = false,
    menubar = false,
    scrollbars = true,
    resizable = true,
    centerScreen = true,
  }: OpenWindowPopupOptions = {},
) {
  let left = 0;
  let top = 0;

  if (centerScreen) {
    left = window.screen.width / 2 - width / 2;
    top = window.screen.height / 2 - height / 2;
  }

  const features = [
    `width=${width}`,
    `height=${height}`,
    `top=${top}`,
    `left=${left}`,
    `toolbar=${toolbar ? "yes" : "no"}`,
    `menubar=${menubar ? "yes" : "no"}`,
    `scrollbars=${scrollbars ? "yes" : "no"}`,
    `resizable=${resizable ? "yes" : "no"}`,
  ].join(",");

  const popupWindow = window.open(url, title, features);

  if (popupWindow) {
    const checkPopupClosed = setInterval(() => {
      if (popupWindow.closed) {
        clearInterval(checkPopupClosed);
        onClose?.();
      }
    }, 500);
  }

  return popupWindow;
}
